import { dateRangeStringifyFn } from '@iris/modules/module-filters-v2/utils';
import { IrisFilterChipRenderingOptions } from './chip-rendering-options';
import { defaultChipRenderingOptions } from './default-chip-rendering-options';

export function dateRangeChipRenderingOptions(dateStringifyFn: (date: Date) => string): IrisFilterChipRenderingOptions {
  return defaultChipRenderingOptions(dateRangeStringifyFn(dateStringifyFn));
}
